import { categories } from "@/mocks/community";

interface CategoryTabsProps {
  value: string;
  onChange: (key: string) => void;
}

export default function CategoryTabs({ value, onChange }: CategoryTabsProps) {
  const tabs = [{ key: "all", name: "全部板块" }, ...categories.map((c) => ({ key: c.key, name: c.name }))];

  return (
    <div className="flex flex-wrap gap-2">
      {tabs.map((tab) => {
        const active = value === tab.key;
        return (
          <button
            key={tab.key}
            type="button"
            onClick={() => onChange(tab.key)}
            aria-pressed={active}
            className={`whitespace-nowrap rounded-full border px-4 py-2 text-sm font-medium transition-colors ${
              active
                ? "border-primary-500 bg-primary-500 text-background-50"
                : "border-background-300 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
            }`}
          >
            {tab.name}
          </button>
        );
      })}
    </div>
  );
}